import axios from "axios";

// Separate from `apiBase` (../../api.js) on purpose: that client points at
// SDF's own backend and attaches an SDF auth token + 401 refresh/logout
// interceptors, neither of which applies to this public, unauthenticated
// MyWash endpoint. koordinacija/AKTIVIRAJ-MYWASH-2026-10-10.md.
const MYWASH_PUBLIC_API_BASE = "https://api.mywash.rs/api/public/activation";
const MAX_MACS_PER_REQUEST = 50;

class MyWashActivationStatusService {
  // GET /api/public/activation/status?macs=... — returns
  // { [mac]: 'active' | 'available' | 'unavailable' }. Any failure (CORS,
  // network, 4xx/5xx) resolves to {} rather than throwing, so a MyWash
  // outage never breaks the SDF device page — it just shows "-" for MyWash.
  fetchStatuses = async (macs) => {
    const uniqueMacs = Array.from(new Set((macs || []).filter(Boolean))).slice(
      0,
      MAX_MACS_PER_REQUEST
    );
    if (uniqueMacs.length === 0) return {};
    try {
      const response = await axios.get(`${MYWASH_PUBLIC_API_BASE}/status`, {
        params: { macs: uniqueMacs.join(",") },
      });
      return response?.data?.data || {};
    } catch (err) {
      return {};
    }
  };
}

export default new MyWashActivationStatusService();
